import { render, staticRenderFns } from "./DVIRTemplateEditor.vue?vue&type=template&id=71a1f1d6&scoped=true&"
import script from "./DVIRTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./DVIRTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./DVIRTemplateEditor.vue?vue&type=style&index=0&id=71a1f1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1f1d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
